var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<panel panel-title=\"{{::$ctrl.title|| 'Nav Tree'| titlecase }}\" type=\"{{$ctrl.panelType}}\" raw=\"true\"><div max-height=\"{{$ctrl.maxPanelHeight}}\" class=\"p-y-1\"><auto-query-nav nav=\"$ctrl.navs[0]\"></auto-query-nav></div></panel>";
var id1="auto-query-nav-panel.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;